// extracted by mini-css-extract-plugin
export var container = "_4e-0";
export var icon = "_4e-1";
export var text = "_4e-2";